import { render } from "./SingleFullPage.vue?vue&type=template&id=37d711ee&ts=true"
import script from "./SingleFullPage.vue?vue&type=script&lang=ts"
export * from "./SingleFullPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__